import { all } from 'redux-saga/effects';
import parentPackages from './package';

export const parentPackagesSaga = function* root() {
  yield all([parentPackages()]);
};
